<template>
  <div class="megamenu-service-type-pages mx-8 my-10">
    <p
      class="text-primary font-bold uppercase text-sm tracking-[.39px] flex flex-row gap-2 items-center text-[#213756_!important] font-semibold text-lg"
    >
      {{ $t("mainmenu.serviceTypePage") }}
    </p>

    <div class="flex flex-col flex-wrap max-h-[25rem] mt-6">
      <LayoutMegaMenuItem v-for="item in serviceTypePageMenu" :key="item.title" :title="item.title" :href="item.href" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from "@/stores/global";

const globalStore = useGlobalStore();
const serviceTypePageMenu = computed(() => globalStore.serviceTypePageMenu);
</script>
